import { Directive, TemplateRef } from '@angular/core'

@Directive({
  selector: '[fieldLabel]',
  standalone: false,
})
export class FormFieldLabelDirective {
  constructor(public template: TemplateRef<any>) {}
}

@Directive({
  selector: '[fieldPrefix]',
  standalone: false,
})
export class FormFieldPrefixDirective {
  constructor(public template: TemplateRef<any>) {}
}
@Directive({
  selector: '[fieldSuffix]',
  standalone: false,
})
export class FormFieldSuffixDirective {
  constructor(public template: TemplateRef<any>) {}
}

@Directive({
  selector: '[fieldError]',
  standalone: false,
})
export class FormFieldErrorDirective {
  constructor(public template: TemplateRef<any>) {}
}
